import React from 'react';
import NavigationBar from './NavigationBar';
import { UserConsumer } from '../contexts/UserContext';
import Header from './Header';
import { Container } from 'reactstrap';

const Layout = ({ children }) => {
    return (
        <Container fluid className="vh-100 w-100 p-0 m-0 d-flex flex-column h-100 flex-grow-1">
            <Header />
            <UserConsumer>
                {({ user }) => (
                    <div style={{ display: 'flex' }} className='flex-grow-1'>
                        <div style={{ width: 'auto', backgroundColor: '#f9f9f9', borderRight: '1px solid #ccc' }} className='flex-grow-1'>
                            <NavigationBar currentUser={user} />
                        </div>
                        <div  className='w-100'>
                            {children}
                        </div>
                    </div>
                )}
            </UserConsumer>
        </Container>

    );
};

export default Layout;